import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import { isUndefined } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Select, Input } from '~/components/Form';
import { t, validCharacters } from '~/helpers';
import { updateConfiguracaoAlarmeTanque } from '~/store/modules/configuracaoalarmetanque/actions';

export default function CreateOrUpdate({ reference, create, data }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.configuracaoalarmetanque
  );

  const initials = create ? data : { ...find, ...data };

  const [gera, setGera] = useState('');

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        nomeApresentacaoConfigAlarme: Yup.string()
          .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param,
        idCliente: client,
        geraAlarmeConfigAlarme: gera,
      };

      await dispatch(updateConfiguracaoAlarmeTanque(objSend, params));
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  useEffect(() => {
    const { geraAlarmeConfigAlarme } = find;

    if (!isUndefined(geraAlarmeConfigAlarme)) {
      setGera(geraAlarmeConfigAlarme);
    }
  }, [find]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="codigoLabelSistema"
            label={t(
              's.configuracao.configuracaoalarmetanque.codigolabelsistema'
            )}
            value={t(initials.codigoLabelSistema)}
            disabled
          />

          <Input
            name="nomeApresentacaoConfigAlarme"
            label={t(
              's.configuracao.configuracaoalarmetanque.nomeapresentacaoconfigalarmetanque'
            )}
          />

          <Select
            name="geraAlarmeConfigAlarme"
            variant="outlined"
            size="small"
            label={t(
              's.configuracao.configuracaoalarmetanque.geraalarmeconfigalarmetanque'
            )}
            options={[
              { value: 'S', label: t('s.geral.opcoes.sim') },
              { value: 'N', label: t('s.geral.opcoes.nao') },
            ]}
            getValue={(value) => setGera(value)}
          />

          {gera == 'S' && (
            <Select
              name="acionaIOConfigAlarme"
              variant="outlined"
              size="small"
              label={t(
                's.configuracao.configuracaoalarmetanque.acionaioconfigalarmetanque'
              )}
              options={[
                { value: 0, label: t('s.geral.acionamento.naoaciona') },
                { value: 1, label: t('s.geral.acionamento.prioridadebaixa') },
                { value: 2, label: t('s.geral.acionamento.prioridademedia') },
                { value: 3, label: t('s.geral.acionamento.prioridadealta') },
              ]}
            />
          )}
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
